import React from 'react';
import filesize from 'filesize';
import { useDispatch } from 'react-redux';
import { Box, IconButton, Typography } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';
import { VideocamOutlined } from '@material-ui/icons';
import { ideaCreateActions, challengeActions } from '../../actions';
import { ideaUpdateActions } from '../../actions/ideaUpdate.actions';

function VideoPreview({ video, isEdit=false, isChallenge=false }) {
  const dispatch = useDispatch();

  function removeVideo() {
    if (isEdit && !isChallenge) {
      dispatch(ideaUpdateActions.removeVideo(video.id ?? video._id));
    } 
    
    if (!isEdit && !isChallenge) {
      dispatch(ideaCreateActions.removeVideo());
    }

    if (isChallenge && !isEdit) {
      dispatch(challengeActions.removeChallengeVideo());
    }
  }

  function getFileSize(rawSize) {
    rawSize = rawSize ? rawSize : 10;
    const size = parseFloat(rawSize);
    return filesize(size)
  }

  return (
    <Box width="100%">
      <Box display='flex' alignItems='center' justifyContent="space-between">
        <Box display='flex' alignItems='center'>
          <VideocamOutlined />
          <Box marginLeft={2}>
            <Typography variant='subtitle2'>{video.name ?? video.fileName}</Typography>
            <Typography variant='caption'>
              {getFileSize(video.readableSize) ?? getFileSize(video.size)}
            </Typography>
          </Box>
        </Box>
        {isEdit && (
          <IconButton onClick={removeVideo}>
            <Delete />
          </IconButton>
        )}
      </Box>

      <video style={{ width: '100%' }} height="255" controls>
        <source
          src={video.preview ?? video.url}
          type={video.type}
        />
      </video>
    </Box>
  );
}

export { VideoPreview };